// @ts-nocheck
import React, { createContext, useState, VFC } from "react";
import ja from "../../intl/locales/ja.json";
import en from "../../intl/locales/en.json";
import { IntlProvider } from "react-intl";
 
interface Props {
  children: React.ReactNode;
}
 
interface Lang {
  switchLang(lang: string): void;
}
 
export const Context = createContext<Lang>({} as Lang);
 
export const IntlProviderWrapper: VFC<Props> = (props) => {
  const langs = [
    { locale: "ja", messages: ja },
    { locale: "en", messages: en },
  ];
  const [lang, setLang] = useState(langs.find((lang) => lang.locale === navigator.language.substring(0,2)));
 
  const switchLang = (locale: string) => {
    const changeLang = langs.find((lang) => lang.locale === locale);
    if (changeLang == null) {
      return;
    }
    setLang(changeLang);
  };
 
  return (
    <Context.Provider value={{ switchLang }}>
      <IntlProvider {...lang}>{props.children}</IntlProvider>
    </Context.Provider>
  );
};
 
export default IntlProviderWrapper;